export function SectionTitle({ kicker, title, className = "", light = false }) {
  return (
    <div className={className}>
      {kicker && (
        <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-gold">
          {kicker}
        </p>
      )}
      <h2
        className={`font-heading mt-2 inline-block gold-underline text-4xl font-800 tracking-tight sm:text-5xl ${
          light ? "text-white" : "text-white"
        }`}
        style={{ fontWeight: 800 }}
      >
        {title}
      </h2>
    </div>
  );
}
